import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

// TODO: Create generic Icon component that imports icons on demand

const labelA = dynamic(() => import("../Icons/EnergyClass/EnergyClassA"));
const labelB = dynamic(() => import("../Icons/EnergyClass/EnergyClassB"));
const labelC = dynamic(() => import("../Icons/EnergyClass/EnergyClassC"));
const labelD = dynamic(() => import("../Icons/EnergyClass/EnergyClassD"));
const labelE = dynamic(() => import("../Icons/EnergyClass/EnergyClassE"));
const labelF = dynamic(() => import("../Icons/EnergyClass/EnergyClassF"));
const labelG = dynamic(() => import("../Icons/EnergyClass/EnergyClassG"));

const classComponentMap = {
  A: labelA,
  B: labelB,
  C: labelC,
  D: labelD,
  E: labelE,
  F: labelF,
  G: labelG,
};

const ProductEnergyClass = ({
  energyClass,
  width = "70px",
  isClickable = false,
  onClick,
}) => {
  if (classComponentMap[energyClass]) {
    const Class = classComponentMap[energyClass];

    return isClickable ? (
      <a
        role="button"
        href="#"
        title="Vezi eticheta energetica"
        onClick={onClick}
      >
        <Class width={width} />
      </a>
    ) : (
      <Class width={width} />
    );
  }

  return null;
};

ProductEnergyClass.propTypes = {
  energyClass: PropTypes.string.isRequired,
  width: PropTypes.string,
  isClickable: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ProductEnergyClass;
